var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongBofang(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.028V3.972a.5.5 0 01.79-.407l5.64 4.028a.5.5 0 010 .814l-5.64 4.028a.5.5 0 01-.79-.407z",
    stroke: "#3F465C",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgMTIuMDI4NFYzLjk3MTU5QzUgMy41NjQ5MSA1LjQ1OTY5IDMuMzI4MzUgNS43OTA2MiAzLjU2NDczTDExLjQzMDQgNy41OTMxM0MxMS43MDk2IDcuNzkyNTQgMTEuNzA5NiA4LjIwNzQ2IDExLjQzMDQgOC40MDY4N0w1Ljc5MDYyIDEyLjQzNTNDNS40NTk2OCAxMi42NzE3IDUgMTIuNDM1MSA1IDEyLjAyODRaIiBzdHJva2U9IiMzRjQ2NUMiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgTongyongBofang as ReactComponent };